export const pseudoRandomId = () => Math.random().toString(36).slice(2);
